import React from "react";
import T from "prop-types";

import { PageMessageError, PageMessageEmpty } from "2g-page-message";

import useZakaznikDetail from "./useZakaznikDetail";
import useMessages from "./i18n/useMessages";
import ZakaznikDetailContent from "./ZakaznikDetailContent";

export function ZakaznikDetail({ ico }) {
  const { notfound } = useMessages();
  const { zakaznik, loading, loaded, error } = useZakaznikDetail({ ico });

  return error ? (
    <PageMessageError error={error} />
  ) : loaded && !zakaznik ? (
    <PageMessageEmpty message={notfound({ ico })} />
  ) : (
    <ZakaznikDetailContent zakaznik={zakaznik} loading={loading} />
  );
}

ZakaznikDetail.propTypes = {
  ico: T.string.isRequired
};

export default React.memo(ZakaznikDetail);
